<script setup>
// import { useUserStore } from '@/plugins/store/user.ts'
import { useRouter } from 'vue-router'

// const user = useUserStore()
const router = useRouter()
</script>

<template>
	<v-card>
		<v-tabs
			color="primary"
			bg-color="background"
			center-active
		>
			<v-tab @click="router.push('/admin/word')">Words</v-tab>
			<v-tab>Two</v-tab>
			<v-tab>Three</v-tab>
			<v-tab>Four</v-tab>
			<v-tab>Five</v-tab>
			<v-tab>Six</v-tab>
		</v-tabs>
	</v-card>
	<router-view/>
</template>

<style scoped>
</style>